import { useState } from "react";
import { C } from "../../constants/theme";

const LEVELS = [
  { name:"Remember",   desc:"Recall facts and basic concepts" },
  { name:"Understand", desc:"Explain ideas in their own words" },
  { name:"Apply",      desc:"Use what they know in new situations" },
  { name:"Analyse",    desc:"Draw connections, compare, contrast" },
  { name:"Evaluate",   desc:"Justify a stance or decision with reasoning" },
  { name:"Create",     desc:"Produce something new — original work, fresh ideas" },
];

const BloomsTaxonomy = () => {
  const [active, setActive] = useState(0);
  return (
    <div style={{ background:C.navy, borderRadius:20, padding:"32px 36px" }}>
      <div style={{ marginBottom:24 }}>
        <div style={{ fontFamily:"Fredoka One", fontSize:20, color:C.yellow, marginBottom:8 }}>Bloom's Taxonomy — All 6 Levels</div>
        <p style={{ fontFamily:"Nunito", fontSize:14, color:"rgba(255,255,255,0.75)", margin:0, lineHeight:1.7 }}>
          Every concept is taught at all six cognitive levels. Children are never just memorising. They are always thinking. <span style={{ fontStyle:"italic", color:C.yellow }}>Tap each level to learn more.</span>
        </p>
      </div>
      <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:18 }}>
        {LEVELS.map(({ name }, i) => (
          <button key={name} onClick={()=>setActive(i)} style={{
            background: active === i ? C.rainbow[i] : "rgba(255,255,255,0.08)",
            color: active === i ? C.white : "rgba(255,255,255,0.7)",
            fontFamily:"Nunito", fontWeight:700, fontSize:12,
            padding:"8px 16px", borderRadius:100,
            border: active === i ? `2px solid ${C.rainbow[i]}` : "2px solid rgba(255,255,255,0.15)",
            cursor:"pointer", transition:"all 0.25s ease",
            transform: active === i ? "scale(1.05)" : "scale(1)",
          }}>{i + 1}. {name}</button>
        ))}
      </div>
      <div style={{
        background:"rgba(255,255,255,0.06)",
        borderLeft:`3px solid ${C.rainbow[active]}`,
        borderRadius:8, padding:"14px 20px", minHeight:50,
      }}>
        <div style={{ fontFamily:"Fredoka One", fontSize:15, color:C.rainbow[active], marginBottom:4 }}>
          {LEVELS[active].name}
        </div>
        <p style={{ fontFamily:"Nunito", fontSize:14, color:"rgba(255,255,255,0.8)", margin:0, lineHeight:1.65 }}>
          {LEVELS[active].desc}
        </p>
      </div>
    </div>
  );
};

export default BloomsTaxonomy;
